module.exports = __webpack_public_path__ + "img/L4-1.png";